import { AdjustmentFieldsFragment, CapSpaceFieldsFragment, DraftPickFieldsFragment, TransactionAssetInput } from "../__generated__/types";
import { ExtendedTransactionAssetInput } from "../types";

export function classNames(...classes: string[]) : string {
  return classes.filter(Boolean).join(' ')
}

export function nFormatter(num: number, digits = 0): string {
  const posNeg = num < 0 ? '-' : '';
  num = Math.abs(num);
  
  const symbols = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'B' },
    { value: 1e12, symbol: 'T' },
  ];

  if (num < 1) return num.toString();
  const regex = /\.0+$|(\.[0-9]*[1-9])0+$/;
  const i = symbols.reverse().findIndex(s => num >= s.value);
  return posNeg + (num / symbols[i].value).toFixed(digits).replace(regex, '$1') + symbols[i].symbol;
}

export function draftPickTraded(draftPick: DraftPickFieldsFragment) : boolean {
  return draftPick.franchise?.id !== draftPick.originalFranchise?.id
}

export function removeTempId(input: ExtendedTransactionAssetInput) : TransactionAssetInput {
  const { tempId, ...rest } = input;
  return rest;
}

export function getTempId() : string {
  return Math.random().toString(36).substr(2, 9);
}

// export function capSpaceTotaled(collection: (CapSpaceFieldsFragment[] | AdjustmentFieldsFragment[]), franchiseId: string) : number {
//   return collection.reduce((total, item) => {
//     if (item.__typename === 'CapSpace' && item.owner?.id === franchiseId) {
//       return total - (item.amount || 0);
//     } else {
//       return total + (item.amount || 0);
//     }
//   }, 0);
// }

export function capSpaceTotaledForHashCollection(collection: { adjustments: AdjustmentFieldsFragment[]; capSpacesGiven: CapSpaceFieldsFragment[]; capSpacesReceived: CapSpaceFieldsFragment[] }) : number {
  let total = 0;
  collection.adjustments.forEach((item) => {
    total += item.amount || 0;
  });
  collection.capSpacesGiven.forEach((item) => {
    total -= item.amount || 0;
  });
  collection.capSpacesReceived.forEach((item) => {
    total += item.amount || 0;
  });
  return total;
}